<avi-health-score
    *ngIf="pool"
    id="pool-health-score-{{ poolRef | slug }}"
    [runTime]="pool"
    (onViewHealthClick)="navigateToHealthPage()"
></avi-health-score>
